import React from "react";
import { FormattedMessage } from "react-intl";

export const JoinOurNewsletterText = () => {
  // Join Our Newsletter
  return <FormattedMessage id="lang-join-our-newsletter" />;
};

export const UrlCopiedText = () => {
  // Url Copied
  return <FormattedMessage id="lang-url-copied" />;
};

export const ViewDetailsText = () => {
  // View Details
  return <FormattedMessage id="lang-view-details" />;
};

export const ViewAllText = () => {
  // View All
  return <FormattedMessage id="lang-view-all" />;
};

export const ViewFullVideoText = () => {
  // View Full Video
  return <FormattedMessage id="lang-view-full-video" />;
};

export const ApplyText = () => {
  // Apply
  return <FormattedMessage id="lang-apply" />;
};

export const InquiryText = () => {
  // Inquiry
  return <FormattedMessage id="lang-inquiry" />;
};

export const TermsConditionsApplyText = () => {
  // Terms and Conditions apply
  return <FormattedMessage id="lang-terms-conditions-apply" />;
};

export const LearnMoreText = () => {
  // Learn More
  return <FormattedMessage id="lang-learn-more" />;
};

export const JoinMomentumMembershipText = () => {
  // Join the Momentum Membership to enjoy exclusive benefits
  return <FormattedMessage id="lang-join-momentum-membership" />;
};

export const LoadMoreText = () => {
  // Load More
  return <FormattedMessage id="lang-load-more" />;
};

export const PrivacyPolicyText = () => {
  // Privacy Policy
  return <FormattedMessage id="lang-privacy-policy" />;
};

export const ViewRulesText = () => {
  // View Rules
  return <FormattedMessage id="lang-view-rules" />;
};

export const NumberofSeatsbyFloorText = () => {
  // Number of Seats by Floor
  return <FormattedMessage id="lang-number-of-seats-by-floor" />;
};

export const TheSeatsAboveAreSubjectToSomeVariationsText = () => {
  // The seats above are subject to some variations.
  return (
    <FormattedMessage id="lang-the-seats-above-are-subject-to-some-variations" />
  );
};

export const BackToMediaCenterText = () => {
  // Back To Media Center
  return <FormattedMessage id="lang-back-to-media-center" />;
};

export const BookYourMeetingText = () => {
  // Book Your Meeting
  return <FormattedMessage id="lang-book-your-meeting" />;
};

export const ConnectToLinkedinText = () => {
  // Connect To Linkedin
  return <FormattedMessage id="lang-connect-to-linkedin" />;
};

export const HotelReservationsText = () => {
  // Hotel Reservations
  return <FormattedMessage id="lang-hotel-reservations" />;
};

export const PhoneText = () => {
  // Phone
  return <FormattedMessage id="lang-phone" />;
};

export const ConnectWithUsText = () => {
  // Connect With Us
  return <FormattedMessage id="lang-connect-with-us" />;
};

export const MapText = () => {
  // Map
  return <FormattedMessage id="lang-map" />;
};

export const FaxText = () => {
  // Fax
  return <FormattedMessage id="lang-fax" />;
};

export const NoticeText = () => {
  // Notice
  return <FormattedMessage id="lang-notice" />;
};

export const CareersText = () => {
  // AboutUsCareers
  return <FormattedMessage id="lang-careers" />;
};

export const SignUpNowText = () => {
  // Sign Up Now
  return <FormattedMessage id="lang-sign-up-now" />;
};

export const SubmitLoadingText = () => {
  return <FormattedMessage id="lang-submit-loading" />;
};

export const OkText = () => {
  //Ok
  return <FormattedMessage id="lang-ok" />;
};

export const AllText = () => {
  // All
  return <FormattedMessage id="lang-all" />;
};

export const BookNowText = () => {
  // Book Now
  return <FormattedMessage id="lang-book-now" />;
};

export const ReserveText = () => {
  // Reserve
  return <FormattedMessage id="lang-reserve" />;
};

export const BookYourTicketText = () => {
  // Book Your Ticket
  return <FormattedMessage id="lang-book-your-ticket" />;
};

export const BookYourRoomText = () => {
  // Book Your Room
  return <FormattedMessage id="lang-book-your-room" />;
};

export const BookYourEventText = () => {
  // Book Your Event
  return <FormattedMessage id="lang-book-your-event" />;
};

export const BookYourTableText = () => {
  // Book Your Table
  return <FormattedMessage id="lang-book-your-table" />;
};

export const BookSplashBayText = () => {
  // Book Splash Bay
  return <FormattedMessage id="lang-book-splash-bay" />;
};

export const PdfDownloadText = () => {
  // PDF Download
  return <FormattedMessage id="lang-pdf-download" />;
};

export const GoBackToHomepageText = () => {
  // Go Back to the Home Page
  return <FormattedMessage id="lang-go-back-to-homepage" />;
};

export const SeeTheMenuText = () => {
  // See the Menu
  return <FormattedMessage id="lang-see-the-menu" />;
};

export const RoomConfigurationText = () => {
  // Room Configuration
  return <FormattedMessage id="lang-room-configuration" />;
};

export const RoomSizeText = () => {
  // Room Size
  return <FormattedMessage id="lang-room-size" />;
};

export const RoomTypeText = () => {
  // Room Type
  return <FormattedMessage id="lang-room-type" />;
};

export const ViewTypeText = () => {
  // View Type
  return <FormattedMessage id="lang-view-type" />;
};

export const ExtraChargeText = () => {
  // Extra Charge
  return <FormattedMessage id="lang-extra-charge" />;
};

export const OffersText = () => {
  // Offers
  return <FormattedMessage id="lang-offers" />;
};

export const StayText = () => {
  // Stay
  return <FormattedMessage id="lang-stay" />;
};

export const ShopText = () => {
  // Shop
  return <FormattedMessage id="lang-shop" />;
};

export const MeetText = () => {
  // Meet
  return <FormattedMessage id="lang-meet" />;
};

export const CasinoText = () => {
  // Casino
  return <FormattedMessage id="lang-casino" />;
};

export const MomentumLifestyleText = () => {
  //  Momentum Lifestyle
  return <FormattedMessage id="lang-momentum-lifestyle" />;
};

export const AboutUsText = () => {
  // About Us
  return <FormattedMessage id="lang-about-us" />;
};

export const RecommendationText = () => {
  // recommendation
  return <FormattedMessage id="lang-recommendation" />;
};

export const FacilityServicesText = () => {
  // Facility & Services
  return <FormattedMessage id="lang-facility-services" />;
};

export const SplashBayText = () => {
  // Splash Bay
  return <FormattedMessage id="lang-splash-bay" />;
};

export const EntertainmentText = () => {
  // Entertainment
  return <FormattedMessage id="lang-entertainment" />;
};

export const MeetingRoomText = () => {
  // Meeting Room
  return <FormattedMessage id="lang-meeting-room" />;
};

export const FloorGuideText = () => {
  // Floor Guide
  return <FormattedMessage id="lang-floor-guide" />;
};

export const LocationText = () => {
  // Location
  return <FormattedMessage id="lang-location" />;
};

export const CapacityText = () => {
  // Capacity
  return <FormattedMessage id="lang-capacity" />;
};

export const RestaurantTypeText = () => {
  // Restaurant Type
  return <FormattedMessage id="lang-restaurant-type" />;
};

export const RestaurantInformationText = () => {
  // Restaurant Information
  return <FormattedMessage id="lang-restaurant-information" />;
};

export const CapacitySizeText = () => {
  // Capacity/Size
  return <FormattedMessage id="lang-capacity-size" />;
};

export const CategoryText = () => {
  // Category
  return <FormattedMessage id="lang-category" />;
};

export const WeekdaysText = () => {
  // Weekdays
  return <FormattedMessage id="lang-weekdays" />;
};

export const WeekendsHolidaysText = () => {
  // Weekends / Holidays
  return <FormattedMessage id="lang-weekends-holidays" />;
};

export const GeneralText = () => {
  // General
  return <FormattedMessage id="lang-general" />;
};

export const SummerSeasonText = () => {
  // Summer Season
  return <FormattedMessage id="lang-summer-season" />;
};

export const AdultsText = () => {
  // Adults
  return <FormattedMessage id="lang-adults" />;
};

export const ChildrenText = () => {
  // Children
  return <FormattedMessage id="lang-children" />;
};

export const ShopTypeText = () => {
  // Shop Type
  return <FormattedMessage id="lang-shop-type" />;
};

export const OperatingHoursText = () => {
  // Operating Hours
  return <FormattedMessage id="lang-operating-hours" />;
};

export const OpenHoursText = () => {
  // Open Hours
  return <FormattedMessage id="lang-open-hours" />;
};

export const FacilityInformationText = () => {
  // Facility Information
  return <FormattedMessage id="lang-facility-information" />;
};

export const OperationInformationCautionText = () => {
  // Operation Information and Caution
  return <FormattedMessage id="lang-operation-information-caution" />;
};

export const ViewMenuText = () => {
  // View Menu
  return <FormattedMessage id="lang-view-menu" />;
};

export const CheckInCheckOutText = () => {
  // Check in - Check out
  return <FormattedMessage id="lang-check-in-check-out" />;
};

export const NumberofGuestsText = () => {
  // Number of Guests
  return <FormattedMessage id="lang-number-of-guests" />;
};

export const OfferCodeText = () => {
  // Offer Code
  return <FormattedMessage id="lang-offer-code" />;
};

export const CheckAvailabilityText = () => {
  // Check Availability
  return <FormattedMessage id="lang-check-availability" />;
};

export const InformationAlertText = () => {
  // Information Alert
  return <FormattedMessage id="lang-information-alert" />;
};

export const EditText = () => {
  // Edit
  return <FormattedMessage id="lang-edit" />;
};

export const SwitchLanguageText = () => {
  // Switch Lanugage
  return <FormattedMessage id="switch-language" />;
};

export const NotFoundInstruction1 = () => {
  // OOPS! Looks Like You're Lost
  return <FormattedMessage id="lang-not-found-instruction-1" />;
};

export const NotFoundInstruction2 = () => {
  // Uh-oh! It seems you've stumbled upon a page that doesn't exist.
  return <FormattedMessage id="lang-not-found-instruction-2" />;
};

export const NotFoundInstruction3 = () => {
  // Don't worry, though. We're here to help you find your way back on
  // track.
  return <FormattedMessage id="lang-not-found-instruction-3" />;
};

export const MoreOffersComingSoonText = () => {
  // More Offers Coming Soon
  return <FormattedMessage id="lang-more-offers-coming-soon" />;
};

export const NoOffersDescriptionText = () => {
  // Hi there! No offers at the moment, but don't miss out - sign up for
  // our newsletter to stay updated on upcoming deals!
  return <FormattedMessage id="lang-no-offers-description" />;
};

export const CloseText = () => {
  // Close
  return <FormattedMessage id="lang-close" />;
};

export const BeInformedText = () => {
  // Be Informed
  return <FormattedMessage id="lang-be-informed" />;
};

export const FreeShuttleBusServiceText = () => {
  // Free Shuttle Bus Service
  return <FormattedMessage id="lang-free-shuttle-bus-service" />;
};

export const DashboardText = () => {
  // Dashboard
  return <FormattedMessage id="lang-dashboard" />;
};

export const AccountText = () => {
  // Account
  return <FormattedMessage id="lang-account" />;
};

export const RoomNameText = () => {
  // Room Name
  return <FormattedMessage id="lang-room-name" />;
};

export const RoomDimensionsText = () => {
  // Room Dimensions
  return <FormattedMessage id="lang-room-dimension" />;
};

export const AreaText = () => {
  // Area
  return <FormattedMessage id="lang-area" />;
};

export const LengthText = () => {
  // Length
  return <FormattedMessage id="lang-length" />;
};

export const WidthText = () => {
  // Width
  return <FormattedMessage id="lang-width" />;
};

export const HeightText = () => {
  // Height
  return <FormattedMessage id="lang-height" />;
};

export const ResetSubmitText = () => {
  // Reset Submit
  return <FormattedMessage id="lang-reset-submit" />;
};

export const HideTodayText = () => {
  return <FormattedMessage id="lang-hide-today" />;
};

export const IAgreeText = () => {
  return <FormattedMessage id="lang-agree" />;
};

export const IDisagreeText = () => {
  return <FormattedMessage id="lang-disagree" />;
};

export const InvalidOldPasswordText = () => {
  return <FormattedMessage id="lang-invalid-old-password" />;
};

export const CurrentNewPasswordMatches = () => {
  return <FormattedMessage id="lang-current-new-password-same" />;
};

export const InvalidFormatPasswordText = () => {
  return (
    <FormattedMessage
      id="lang-invalid-format-password"
      values={{ nbsp: <br></br> }}
    />
  );
};

export const InvalidNewPasswordText = () => {
  return <FormattedMessage id="lang-invalid-new-password" />;
};

export const ServiceErrorText = () => {
  return <FormattedMessage id="lang-service-error" />;
};

export const PasswordServiceErrorText = () => {
  return <FormattedMessage id="lang-password-service-error" />;
};

export const ReserveNowText = () => {
  return <FormattedMessage id="lang-reserve-now" />;
};

// ! strivacity
export const KakaoUnlinkErrorText = () => {
  return <FormattedMessage id="lang-kakao-unlink-error" />;
};

export const KakaoLoginError = () => {
  return <FormattedMessage id="lang-kakao-login-error" />;
};

export const KakaoLinkInstructionText = () => {
  return <FormattedMessage id="lang-kakao-link-instruction" />;
};

export const StrivacityUpdateErrorText = () => {
  return <FormattedMessage id="lang-strivacity-update-error" />;
};

export const StrivacityLinkErrorText = () => {
  return <FormattedMessage id="lang-strivacity-link-error" />;
};

export const PhoneNumberNotMatchText = () => {
  return <FormattedMessage id="lang-phone-number-not-match" />;
};

export const UnlinkQuestionText = () => {
  return <FormattedMessage id="lang-unlink-question" />;
};

export const UnlinkText = () => {
  return <FormattedMessage id="lang-unlink" />;
};

export const CancelText = () => {
  return <FormattedMessage id="lang-cancel" />;
};

export const LinkSuccessText = () => {
  return <FormattedMessage id="lang-link-success" />;
};

export const UnlinkSuccessText = () => {
  return <FormattedMessage id="lang-unlink-success" />;
};

export const LinkKakaoAccountText = () => {
  return <FormattedMessage id="lang-link-kakao-account" />;
};
